var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('p',[_vm._v("© 2022 ACCREDITATION COMMISSION FOR HEALTH CARE INC. ALL RIGHTS RESERVED.")])])}]

export { render, staticRenderFns }